export default __webpack_public_path__ + "static/media/Rectangle 2627.1152099c.png";